import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiChatConversationImageModule } from '../fi-chat-conversation-image/fi-chat-conversation-image.module';
import { MatRippleModule } from '@angular/material/core';
import { FiChatConversationUsersListComponent } from './fi-chat-conversation-users-list.component';
import { FiChatConversationUsersListItemComponent } from './fi-chat-conversation-users-list-item/fi-chat-conversation-users-list-item.component';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiProfileIconModule,
        FiChatConversationImageModule,
        MatRippleModule,
        InfoIconModule,
    ],
    declarations: [FiChatConversationUsersListComponent, FiChatConversationUsersListItemComponent],
    exports: [FiChatConversationUsersListComponent],
})
export class FiChatConversationUsersListModule {}
